"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "interval-bar-chart": require("./charts/IntervalBarChart.vue").default,
    "inbody-chart": require("./charts/InBodyChart.vue").default,
    "input-field": require("./inputs/InputField.vue").default,
    "percent-table": require("./tables/PercentTable.vue").default,
    "reference-table": require("./tables/ReferenceTable.vue").default,
    "summary-table": require("./tables/SummaryTable.vue").default,
    "compare-summary-table": require("./tables/CompareSummaryTable.vue").default,
    "compare-report-chart": require("./charts/CompareReportChart.vue").default,
    "compare-percent-report": require("./tables/ComparePercentTable.vue").default,
    "compare-reference-report": require("./tables/CompareReferenceTable.vue").default,
    "statistics-table": require("./tables/StatisticsTable").default
  },

  props: ["report", "edit"],

  mounted: function mounted() {
    window.status = "ready";
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/Report.vue
// module id = EvPZ
// module chunks = 0 1